import React, { useState, useEffect } from 'react';

const Spinner = ({ duration = 2000 }) => {
  const [spin, setSpin] = useState(true);

  useEffect(() => {
    const showSpinner = new Promise((resolve) => {
      setTimeout(() => {
        setSpin(false);
        document.body.classList.remove('no-overflow');
        resolve();
      }, duration);
    });

    showSpinner.then(() => {
      setTimeout(() => {
        const spinner = document.getElementById('spinner');
        if (spinner) spinner.remove();
      }, 500);
    });
  }, [duration]);

  return (
    <div className={`spinner-container ${spin ? 'show' : ''}`} id='spinner'>
      <div className='spinner'>
        <div className='ring'></div>
        <div className='ring'></div>
        <div className='dot'></div>
      </div>
    </div>
  );
};

export default Spinner;
